export default __webpack_public_path__ + "static/media/ic-upload-file.817f81d8.svg";